import IStaticDashboardRoute from '@/routes/types/IStaticDashboardRoute';

const rootRoute: IStaticDashboardRoute = {
    name: 'root',
    path: '/',
    redirect: '/reporting-studio',
};

export default rootRoute;
